import React from 'react';
import Card from 'material-ui/Card';
import CardActions from 'material-ui/Card/CardActions';
import CardContent from 'material-ui/Card/CardContent';
import Button from 'material-ui/Button';
import Typography from 'material-ui/Typography';
import {connect} from "react-redux";
import {viewDetails} from "../actions/data";
import {getDurationJsx, getTimeObjectJsx} from '../service/getDuration';
import AppTheme from './AppTheme';
import {trimToTime} from "../service/timeUtils";
import {GetTime} from "./common/GameTime";
import {isRootEvent} from "../service/isRootEvent";
import {ERROR_EVENT_WORD} from "../reducers/data";

const Event=(props)=> {
    const { event, index, onSelect } = props;

    const sub=event.events && event.events.length>0 ?
         event.events.map((event,i) => <div className={'sub-events-container '+(index%2===0 ? 'white' :'grey')} key={i}>
             <Event event={event}  onSelect={onSelect} index={index+1}/>
    </div>): '';
    let parsedEvent;
    if (event.details)
        parsedEvent = JSON.parse(event.details);
    console.log(parsedEvent);
    return (
        <div className='session-container'>
            <AppTheme>{
                isRootEvent(event) ?
                <GetTime ev={event}/> :
                <Card className={'event-details card ' + ((parsedEvent && parsedEvent.condition && parsedEvent.condition.indexOf(ERROR_EVENT_WORD) != -1) ? 'error': '')}>
                    <CardContent>
                        <Typography className='event-details title' color="textSecondary">
                            {event.type}
                        </Typography>
                        <Typography className='event-details target' variant="headline" component="h3">
                            {event.target}
                        </Typography>
                        {event.label ?
                            <Typography className='dialog-pos' variant="headline" component="h3">
                                {event.label}
                            </Typography> : null}

                        {event.speech ?
                            <Typography className='event-details pos' variant="headline" component="h2">
                                {event.speech}
                            </Typography> : null}
                        <Typography className='event-details pos' color="textSecondary">
                            {trimToTime(event.startTime)} -
                        </Typography>
                        {event.endTime ?
                            <div>
                                <Typography className='event-details pos' color="textSecondary">
                                    {trimToTime(event.endTime)}
                                </Typography>
                                <Typography component="p">
                                    <i>
                                        Время:
                                        {getDurationJsx(event.startTime, event.endTime)}
                                    </i>
                                </Typography>
                            </div>
                            : null}


                    </CardContent>
                    {event.details ?
                        <CardActions>
                            <Button size="small" onClick={() => {
                                onSelect(event)
                            }}>Детализация</Button>
                        </CardActions> : ''}
                </Card>
            }
            </AppTheme>
            { index===undefined? sub:(index%2===0 ? <div className='white column'>{sub}</div> :<div className='grey column'>{sub}</div>)}
        </div>
    );
};

const mapDispatchToProps = (dispatch) => {
    return {
        onSelect: (event) => {
            dispatch(viewDetails(event))
        }
    }
};

const mapStateToProps=(state)=>({filters:state.filters});
const ConnectedEvent=connect(mapStateToProps,mapDispatchToProps)(Event);
export default ConnectedEvent;